<template>
	<tab_header icon="fa-solid fa-fingerprint" title="Biometria" />
	<div class="row">
		<div class="col-12">
			<div class="card shadow-sm border p-5 mb-5">
				<div class="d-flex align-items-center">
					<i class="fa-solid fa-fingerprint fa-2xl me-3"></i>
					<h4 class="text-uppercase m-0">
						Visualização de captura de biometria
					</h4>
				</div>
				<div
					style="min-height: 32px"
					class="m-auto text-center mt-5"
					id="finger">
					<div v-html="image_tag"></div>
				</div>
				<loading_button
					id="get-biometry-button"
					color="success"
					:loading="loading"
					:action="getBiometry">
					Acionar biometria
				</loading_button>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { ref } from 'vue';
	import tab_header from './tab_header.vue';
	import loading_button from '../Widgets/loading_button.vue';
	import axios from 'axios';

	const props = defineProps({
		enrollment_test_id: { type: String, required: true },
		computer_uid: { type: String, required: true },
		request_biometry_url: { type: String, required: true },
	});

	let image_tag = ref('');

	const loading = ref(false);

	async function getBiometry() {
		loading.value = true;

		axios
			.post(props.request_biometry_url, {
				uid: props.computer_uid,
				enrollment_test_id: props.enrollment_test_id,
			})
			.then((response) => {
				//@ts-ignore
				toastr.success('Solicitando biometria');
				image_tag.value = `<img
                            class="img-finger"
                            src="data:image/jpeg;charset=utf-8;base64,${response.data.data.img_jpeg}"
                            width="320px"
                            height="240px"
                            alt="Imagem da biometria"
                        >`;
			})
			.catch((response) => {
				//@ts-ignore
				toastr.error(
					'Erro ao solicitar biometria: ' +
						response.response.data.message
				);
			})
			.finally(() => (loading.value = false));
	}
</script>

<style scoped>
	@media (max-width: 600px) {
		.img-finger {
			width: 150px;
			height: 150px;
		}
	}
</style>
